import { Component, OnDestroy, OnInit } from '@angular/core';
import { GlobalInfoService, AuthenticationService } from '@app/core';
import { DocumentsDataService } from './shared/documents.data.service';
import {
  SeriePredeterminada,
  SubSeriePredeterminada,
  TipoDocumentalPredeterminado,
  ClasificacionPredeterminada,
  Const
} from '@app/shared';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';

export type Action = 'add' | 'update' | 'delete';

@Component({
  selector: 'iw-documents',
  templateUrl: './documents.component.html',
  styleUrls: ['./documents.component.scss'],
  providers: [DocumentsDataService]
})
export class DocumentsComponent implements OnInit, OnDestroy {
  // Variables para determinar la carga de los datos y muestra un mensaje de cargando
  loadingFinishSeries = false;
  loadingFinishSubSeries = false;
  loadingFinishTypeDocumentary = false;
  loadingFinishClassification = false;
  // Activa la pestaña de series
  activateAccessTabSeries = false;
  // Activa la pestaña de subseries
  activateAccessTabSubseries = false;
  // Activa la pestaña de tipos documetales
  activateAccessTabTypesDocumentary = false;
  // Activa la pestaña de clasificación de documentos
  activateAccessTabDocumentClassification = false;
  // Permisos de acciones del usuario
  activateAction = {
    review: false
  };
  series: SeriePredeterminada[] = [];
  subseries: SubSeriePredeterminada[];
  typeDocumentary: TipoDocumentalPredeterminado[];
  documentClassification: ClasificacionPredeterminada[];
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();

  constructor(
    private gis: GlobalInfoService,
    private dds: DocumentsDataService,
    private as: AuthenticationService,
    private toastr: ToastrService) { }

  ngOnInit() {
    // Modificar titulo principal
    this.gis.set({ title: 'Gestión de Documentos' });

    // Permiso de ver del usuario en sesion
    // Series - Subseries - Tipo documentales - clasificación documental
    this.activateAction.review = this.as.confirmPermission(
      Const.types_permissions.administrationDocument,
      Const.types_action_permissions.review
    );

    // Validando si contiene permisos para ver
    if (this.activateAction.review) {
      this.getSeries();
      this.getSubSeries();
      this.getTypeDocumentary();
      this.getDocumentClassification();
    }
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

  /**
   * Obtener series
   *
   * @memberof DocumentsComponent
   */
  getSeries() {
    this.dds.getSeriesDocumentary().subscribe(series => {
      this.series = series;
      this.loadingFinishSeries = true;
    });
  }

  /**
   * Obtener subseries
   *
   * @memberof DocumentsComponent
   */
  getSubSeries() {
    this.dds.getSubseriesDocumentary().subscribe(subseries => {
      this.subseries = subseries;
      this.loadingFinishSubSeries = true;
    });
  }

  /**
   * Obtener un tipo documental
   *
   * @memberof DocumentsComponent
   */
  getTypeDocumentary() {
    this.dds.getTypeDocumentary().subscribe(typeDocumentary => {
      this.typeDocumentary = typeDocumentary;
      this.loadingFinishTypeDocumentary = true;
    });
  }

  /**
   * Obtener clasificación de documentos
   *
   * @memberof DocumentsComponent
   */
  getDocumentClassification() {
    this.dds.getDocumentClassification().subscribe(documentClassification => {
      this.documentClassification = documentClassification;
      this.loadingFinishClassification = true;
    });
  }

  /**
   * Refresca los datos según la acción seleccionada
   *
   * @param {string} data
   * @param {Action} action
   * @memberof DocumentsComponent
   */
  refreshData(data: string, action: Action) {
    if (this.activateAction.review) {
      if (data === 'series') {
        this.getSeries();
        if (action === 'delete') {
          this.getSubSeries();
          this.getTypeDocumentary();
          this.getDocumentClassification();
        }
      } else if (data === 'subseries') {
        this.getSubSeries();
        if (action === 'delete') {
          this.getTypeDocumentary();
          this.getDocumentClassification();
        }
      } else if (data === 'typeDocument') {
        this.getTypeDocumentary();
        if (action = 'delete') {
          this.getDocumentClassification();
        }
      } else if (data === 'documentClassification') {
        this.getDocumentClassification();
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/documents/documents.component.ts